module.exports = __webpack_public_path__ + "media/images/about-2-4f4d917c93e64a2a979f28690a2d242e.jpg";